import { render, staticRenderFns } from "./QuickAccess.vue?vue&type=template&id=cca26556&scoped=true"
import script from "./QuickAccess.vue?vue&type=script&lang=js"
export * from "./QuickAccess.vue?vue&type=script&lang=js"
import style0 from "./QuickAccess.vue?vue&type=style&index=0&id=cca26556&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cca26556",
  null
  
)

export default component.exports